"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _Button = _interopRequireWildcard(require("../../../ui/Button"));
var _selectors = require("../../store/selectors");
var _SaveOfferToBasketModal = require("../../../modals/SaveOfferToBasketModal");
var _selectors2 = require("./store/selectors");
var _actions = require("./store/actions");
var _basket = _interopRequireDefault(require("./img/basket.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var BasketCounter = function BasketCounter() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('BASKET_COUNTER'),
    t = _useTranslation.t;
  var isCompleted = (0, _reactRedux.useSelector)(_selectors2.getIsCompleted);
  var offersCount = (0, _reactRedux.useSelector)(_selectors.getFirstSimplifiedBasketOffersCount);
  var showModal = (0, _react.useCallback)(function () {
    dispatch((0, _SaveOfferToBasketModal.showSaveOfferToBasketModal)());
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.bootstrap)());
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    loading: !isCompleted,
    icon: _basket.default,
    size: _Button.SIZES['EXTRA-MEDIUM'],
    theme: _Button.THEMES.PURPLE,
    onClick: showModal,
    className: _styles.default.root
  }, t('SELECTIONS_COUNT', {
    offersCount: offersCount
  }));
};
var _default = exports.default = (0, _react.memo)(BasketCounter);